import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import {
  Dashboard,
} from 'components/Pages/Dashboard';

const dashboardRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'dashboard',
  element: userBelongsToAnyOf('admin', 'warehouseMember', 'carrierMember', 'companyMember') ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: 'expedicao',
      element: <Dashboard />,
    },
  ],
});

export default dashboardRoutes;
